// extracted by mini-css-extract-plugin
export default {"field":"SkeletonCustomField_field__2gpCo","placeHolderShimmer":"SkeletonCustomField_placeHolderShimmer__F0Z6d"};